var map = {
	"./about/en.json": [
		8346,
		8346
	],
	"./blog/en.json": [
		9525,
		9525
	],
	"./contact/en.json": [
		6221,
		6221
	],
	"./features/en.json": [
		9200,
		9200
	],
	"./home/en.json": [
		4344,
		4344
	],
	"./pricing/en.json": [
		8443,
		8443
	],
	"./shared/en.json": [
		2614,
		2614
	],
	"./why/en.json": [
		7040,
		4659
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7729;
module.exports = webpackAsyncContext;